import { navLinks } from '@/mocks/home';

const quickLinks = [
  { id: 'q-entry', label: '黑料网站入口', href: '#entries' },
  { id: 'q-addr', label: '黑料网站地址', href: '#entries' },
  { id: 'q-backup', label: '黑料网站备用', href: '#entries' },
  { id: 'q-mirror', label: '黑料网站镜像', href: '#mirrors' },
  { id: 'q-nolost', label: '黑料网站防走丢', href: '#guide' },
];

export default function KeywordBar() {
  return (
    <section className="w-full border-b border-background-200/70 bg-background-50">
      <div className="mx-auto flex w-full max-w-7xl flex-col gap-4 px-4 py-5 md:flex-row md:items-center md:justify-between md:px-8">
        <div className="flex items-center gap-3">
          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-800">
            <i className="ri-compass-3-line text-base" aria-hidden="true"></i>
          </span>
          <span className="whitespace-nowrap text-sm font-label font-medium text-foreground-950">快速前往</span>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          {quickLinks.map((link) => (
            <a
              key={link.id}
              href={link.href}
              className="whitespace-nowrap rounded-full border border-background-200 bg-background-100 px-3.5 py-1.5 text-xs font-label text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              {link.label}
            </a>
          ))}
        </div>
        <div className="hidden items-center gap-2 xl:flex">
          {navLinks.slice(1, 4).map((link) => (
            <a
              key={`quick-${link.id}`}
              href={link.href}
              className="whitespace-nowrap text-xs font-label text-foreground-500 transition-colors hover:text-primary-600"
            >
              {link.label}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}